@if (initialized) {
    @if (importData) {
        <mvs-widget [widgetData]="importData"></mvs-widget>
    }
}
